<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="auto !important"
    class="bg-white pos-relative"
    :content-class="isDarkMode ? 'dark-mode' : ''"
  >
    <v-card class="">
      <v-card-title class="fs-1-5r bg-grey mb-2">
        Create New Oolicy
      </v-card-title>
      <v-card-text class="px-2 pb-1">
        <v-text-field
          v-model="newPolicyName"
          lazy
          :rules="newPolicyRules"
          placeholder="New policy name"
          type="text"
          dense
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-4">
        <Button
        :clickAction="createNewPolicyClicked"
        :disabled="isCreateRenameBtnsDisabled"
        width="fit-content"
        btnType="blue"
        class="mr-4"
        text="Create"
        />
        <Button
          :clickAction="closeDialog"
          width="fit-content"
          btnType="grey"
          text="Cancel"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { isFolderNameValid } from '@/utils'
import { mapGetters } from 'vuex'
import { newPolicyRules } from '../../../RenameDialog/RenameDialog'

export default {
  name: 'NewPolicyNameDialog',
  data() {
    return {
      newPolicyName: '',
      dialog: true,
    }
  },
  props: {
    closeDialog: Function,
    createNewPolicy: Function,
  },
  components: { Button },

  computed: {
    ...mapGetters(['policies', 'isDarkMode']),
    newPolicyRules,
    isCreateRenameBtnsDisabled() {
      if (!this.newPolicyName) return true
      else if (!isFolderNameValid(this.newPolicyName)) return true
      else if (this.policies.includes(this.newPolicyName)) return true
      return false
    },
  },
  methods: {
    createNewPolicyClicked() {
      this.createNewPolicy(this.newPolicyName)
      this.closeDialog()
    },
  },
}
</script>
